/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_ViewerInputs */

const en_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewer`)
};

const fr_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecteur`)
};

const de_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuschauer`)
};

const it_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spettatore`)
};

const ru_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зритель`)
};

const es_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espectador`)
};

const zh_cn2_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观众`)
};

const ja_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴者`)
};

const hi_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दर्शक`)
};

const pt_pt2_team_manager_role_viewer = /** @type {(inputs: Team_Manager_Role_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizador`)
};

/**
* | output |
* | --- |
* | "Viewer" |
*
* @param {Team_Manager_Role_ViewerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_viewer = /** @type {((inputs?: Team_Manager_Role_ViewerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_ViewerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_role_viewer(inputs)
	if (locale === "de") return de_team_manager_role_viewer(inputs)
	if (locale === "it") return it_team_manager_role_viewer(inputs)
	if (locale === "ru") return ru_team_manager_role_viewer(inputs)
	if (locale === "es") return es_team_manager_role_viewer(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_role_viewer(inputs)
	if (locale === "ja") return ja_team_manager_role_viewer(inputs)
	if (locale === "hi") return hi_team_manager_role_viewer(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_role_viewer(inputs)
	return en_team_manager_role_viewer(inputs)
});